module.exports = __webpack_public_path__ + "static/media/recycle.3745f439.svg";